/**
 * Role V2 Repository - GraphQL Mutations
 *
 * 7 mutation operations for Role primitive data modification.
 * All mutations use ROLE_FIELDS_FRAGMENT for consistency.
 */

import { gql } from '@apollo/client';
import { ROLE_FIELDS_FRAGMENT } from './fragments';

export const CREATE_ROLE = gql`
  ${ROLE_FIELDS_FRAGMENT}
  mutation CreateRole($tenantId: String!, $input: CreateRoleInput!) {
    createRole(tenantId: $tenantId, input: $input) {
      ...RoleFields
    }
  }
`;

export const UPDATE_ROLE = gql`
  ${ROLE_FIELDS_FRAGMENT}
  mutation UpdateRole($tenantId: String!, $roleId: String!, $input: UpdateRoleInput!) {
    updateRole(tenantId: $tenantId, roleId: $roleId, input: $input) {
      ...RoleFields
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DeleteRole($tenantId: String!, $roleId: String!) {
    deleteRole(tenantId: $tenantId, roleId: $roleId)
  }
`;

export const ADD_PERMISSION = gql`
  ${ROLE_FIELDS_FRAGMENT}
  mutation AddPermission($tenantId: String!, $roleId: String!, $permission: PermissionInput!) {
    addPermission(tenantId: $tenantId, roleId: $roleId, permission: $permission) {
      ...RoleFields
    }
  }
`;

export const REMOVE_PERMISSION = gql`
  ${ROLE_FIELDS_FRAGMENT}
  mutation RemovePermission($tenantId: String!, $roleId: String!, $permissionId: String!) {
    removePermission(tenantId: $tenantId, roleId: $roleId, permissionId: $permissionId) {
      ...RoleFields
    }
  }
`;

export const ADD_ROLE_INHERITANCE = gql`
  ${ROLE_FIELDS_FRAGMENT}
  mutation AddRoleInheritance($tenantId: String!, $roleId: String!, $parentRoleId: String!) {
    addRoleInheritance(tenantId: $tenantId, roleId: $roleId, parentRoleId: $parentRoleId) {
      ...RoleFields
    }
  }
`;

export const REMOVE_ROLE_INHERITANCE = gql`
  ${ROLE_FIELDS_FRAGMENT}
  mutation RemoveRoleInheritance($tenantId: String!, $roleId: String!, $parentRoleId: String!) {
    removeRoleInheritance(tenantId: $tenantId, roleId: $roleId, parentRoleId: $parentRoleId) {
      ...RoleFields
    }
  }
`;
